import { Platform } from 'react-native';
import { devtoolsExchange } from '@urql/devtools';
import { createClient as createUrqlClient, fetchExchange } from 'urql';

import {
  getClientIDHeaders,
  getEphemeralHeaders,
  getGraphQLEndpoint,
  getSgUserAgentHeader,
} from '../utils';
import { authExchange } from './auth-exchange/authExchange';
import type { OfflineCacheExchange } from './graphcache-exchange/createCache';
import { requestPolicyExchange } from './requestPolicyExchange';

/**
 * 📣 PLEASE DO NOT ADD CODE DIRECTLY TO THIS FILE 📣
 * The intention of this file is to exhibit just the high-level urql config
 * so it can be quickly understood, without noise from implementation code 🤘
 */

export const createClient = (offlineCacheExchange: OfflineCacheExchange) => {
  const client = createUrqlClient({
    url: getGraphQLEndpoint(),

    exchanges: [
      devtoolsExchange,
      offlineCacheExchange,
      authExchange,
      fetchExchange,
      requestPolicyExchange,
    ],

    fetchOptions: {
      credentials: 'include',
      headers: {
        ...getEphemeralHeaders(),
        ...getClientIDHeaders(),
        ...(Platform.OS !== 'web' && getSgUserAgentHeader()),
      },
    },
  });

  return client;
};
